import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import {
    PanelBody,
    TextControl,
    ColorPicker,
} from '@wordpress/components';

const Inspector = ( { attributes, setAttributes } ) => {
    const {
        color,
    } = attributes;

    return (
        <>
            <InspectorControls>
                <PanelBody title={ __( 'Settings', 'gridflow' ) } initialOpen={ true }>
                    <TextControl
                        label={ __( 'Color', 'gridflow' ) }
                        value={ color }
                        onChange={ ( value ) => setAttributes( { color: value } ) }
                    />
                    <ColorPicker
                        label={ __( 'Color', 'gridflow' ) }
                        value={ color }
                        enableAlpha={ true }
                        onChange={ ( value ) => setAttributes( { color: value } ) } />
                </PanelBody>
            </InspectorControls>
        </>
    );
};

export default Inspector;
